import { createSlice } from '@reduxjs/toolkit'

// BE-30. Rent, salary, utilities - saved once as a schedule instead of
// retyped into the Expenses form every time. `recurringExpenseList` holds
// the raw paginator object, same shape as expenseSlice.expenseList.
const DEFAULT_FORM = {
    "name": "",
    "credit_category_id": "",
    "credit_sub_category_id": "",
    "bank_id": "",
    "amount": "",
    "method": "",
    "note": "",
    "frequency": "monthly",
    "day_of_month": "",
    "day_of_week": "",
    // Unlike every other field here, blanket-resetting this to "" (the
    // pattern expenseCategorySlice/expenseSlice both use) would make a
    // freshly opened create form validate as inactive - a rule nobody has
    // touched yet should default to on, the same as it would if this field
    // did not exist at all.
    "is_active": true,
}

export const RecurringExpenseSlice = createSlice({
    name: 'recurringExpense',
    initialState: {
        recurringExpenseList: null,
        formValue: { ...DEFAULT_FORM },
    },
    reducers: {
        onChangeRecurringExpenseFormInput: (state, action) => {
            state.formValue[`${action.payload.name}`] = action.payload.value;
        },
        resetRecurringExpenseFormValue: (state) => {
            state.formValue = { ...DEFAULT_FORM };
        },
        setRecurringExpenseList: (state, action) => {
            state.recurringExpenseList = action.payload
        },
    },
})

export const {
    onChangeRecurringExpenseFormInput,
    resetRecurringExpenseFormValue,
    setRecurringExpenseList,
} = RecurringExpenseSlice.actions

export default RecurringExpenseSlice.reducer
